// What a birthday alone gives in each tradition, for the landing's live
// preview. All deterministic (astronomy-engine). No birth time or place yet,
// so the Sun is checked at the first minute of that date anywhere on Earth
// (00:00 at UTC+14) and the last (23:59 at UTC-12); when it changes sign in
// between, both are named. The full chart after the birth details settles it.
import { bodyLongitude, mod360, SIGNS } from "../lib/astro/core.js";
import { lahiriAyanamsa } from "../lib/astro/dailyLenses.js";
import { calculateChineseChart } from "../lib/astro/chinese.js";
import { calculateMayanChart } from "../lib/astro/mayan.js";

// Sanskrit sign names, in the order vedicMath.js uses.
const RASHI = ["Mesha", "Vrishabha", "Mithuna", "Karka", "Simha", "Kanya", "Tula", "Vrishchika", "Dhanus", "Makara", "Kumbha", "Meena"];

const either = (a, b) => (a === b ? a : `${a} or ${b}`);
const HOUR = 3600000;
const SPLIT = "Your birth time and place decide";

export function birthdayLenses({ year, month, day }) {
  const ends = [new Date(Date.UTC(year, month - 1, day, 0, 0) - 14 * HOUR), new Date(Date.UTC(year, month - 1, day, 23, 59) + 12 * HOUR)];
  const tropical = ends.map((d) => Math.floor(mod360(bodyLongitude("sun", d)) / 30));
  const sidereal = ends.map((d) => Math.floor(mod360(bodyLongitude("sun", d) - lahiriAyanamsa(d)) / 30));
  const bd = { birthDate: { year, month, day }, hasBirthTime: false, birthTime: null, birthLocation: null };
  const lenses = [
    {
      key: "western", tradition: "Western", value: either(SIGNS[tropical[0]].name, SIGNS[tropical[1]].name),
      sub: tropical[0] === tropical[1] ? "Sun sign" : SPLIT, accent: "#68B8C8",
    },
    {
      key: "vedic", tradition: "Vedic", value: either(SIGNS[sidereal[0]].name, SIGNS[sidereal[1]].name),
      sub: sidereal[0] === sidereal[1] ? `${RASHI[sidereal[0]]}, by the stars` : SPLIT, accent: "#D4A574",
    },
  ];
  try {
    const c = calculateChineseChart(bd);
    lenses.push({ key: "chinese", tradition: "Chinese", value: `${c.element.name} ${c.animal.name}`, sub: "Year animal", accent: "#C2625A" });
  } catch (e) { /* unavailable for this date */ }
  try {
    const m = calculateMayanChart(bd);
    lenses.push({ key: "mayan", tradition: "Maya", value: `${m.toneIdx + 1} ${m.daySign.name}`, sub: `Day sign, ${m.daySign.symbol.split(" /")[0]}`, accent: "#6DA88F" });
  } catch (e) { /* unavailable for this date */ }
  return lenses;
}
